import { Link } from "react-router-dom";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

const services = [
  {
    icon: "ri-microscope-line",
    title: "Colposcopia Digital",
    description: "Examen especializado del cuello uterino con tecnología digital para detectar lesiones con alta precisión.",
    color: "from-teal-600 to-teal-700",
    tag: "Servicio Principal",
  },
  {
    icon: "ri-test-tube-line",
    title: "Papanicolaou (Pap)",
    description: "Citología cervical para detección temprana de células anormales. Un chequeo esencial para toda mujer.",
    color: "from-emerald-600 to-emerald-700",
    tag: "Más Solicitado",
  },
  {
    icon: "ri-virus-line",
    title: "Tipificación Viral / Genotipificación",
    description: "Prueba molecular avanzada para identificar y genotipificar el Virus del Papiloma Humano de alto riesgo con resultados precisos.",
    color: "from-slate-600 to-slate-700",
    tag: "Diagnóstico Molecular",
  },
  {
    icon: "ri-surgical-mask-line",
    title: "Cirugía Ambulatoria",
    description: "Procedimientos quirúrgicos del cuello uterino de forma ambulatoria, seguros y con rápida recuperación.",
    color: "from-rose-500 to-rose-600",
    tag: "Tratamiento",
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span
              className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-3"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Lo que ofrecemos
            </span>
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Servicios Especializados en{" "}
              <span className="italic font-normal text-teal-600" style={{ fontFamily: "'Lora', serif" }}>
                Salud Femenina
              </span>
            </h2>
          </div>
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-semibold text-sm whitespace-nowrap cursor-pointer border-b border-teal-600 pb-0.5 self-start md:self-auto flex-shrink-0"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Ver todos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {services.map((s) => (
            <div
              key={s.title}
              className={`relative bg-gradient-to-br ${s.color} rounded-2xl p-6 md:p-7 text-white overflow-hidden group hover:-translate-y-1 transition-all duration-300 cursor-pointer`}
            >
              {/* Pattern BG */}
              <div className="absolute top-0 right-0 w-24 h-24 rounded-full bg-white/5 -translate-y-8 translate-x-8" />
              <div className="absolute bottom-0 left-0 w-16 h-16 rounded-full bg-white/5 translate-y-6 -translate-x-6" />

              {/* Tag */}
              <span
                className="inline-block text-xs font-medium bg-white/20 px-3 py-1 rounded-full mb-4"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {s.tag}
              </span>

              {/* Icon */}
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-white/20 mb-4">
                <i className={`${s.icon} text-xl md:text-2xl`}></i>
              </div>

              <h3
                className="font-semibold text-base md:text-lg mb-2 md:mb-3"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {s.title}
              </h3>
              <p
                className="text-white/80 text-sm leading-relaxed mb-5"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {s.description}
              </p>

              <a
                href={WA_LINK}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold border border-white/50 hover:bg-white/20 px-4 py-2 rounded-full transition-all whitespace-nowrap"
                style={{ fontFamily: "'Poppins', sans-serif" }}
                onClick={(e) => e.stopPropagation()}
              >
                <i className="ri-whatsapp-line"></i>
                Agendar
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
